export const selectIsModalActive = (state) => state.errors.get('isModalActive');
export const selectErrorModalContent = (state) => state.errors.get('modalContent');
export const selectAllErrorNotifications = (state) => state.errors.get('errorNotifications');
